export const ChartRoute = {
  Chart: (): string => '/rewards',
  ChartUptime: (): string => '/rewards/uptime',
};
